import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './assets/lang/en.json'
import ae from './assets/lang/ae.json'
import ja from './assets/lang/ja.json'
import constants from './constants'

Vue.use(VueI18n)

const messages = {
  en
}
const i18n = new VueI18n({
  locale: constants.DEFAULT_LANGUAGE,
  messages,
  fallbackLocale: constants.DEFAULT_LANGUAGE
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang.js